<template>
  <div class="wrap">
    <div class="wrap-title">
      <TitleControl title="学习历史" @handleChange="handleSearch">
        <div slot="control" class="control-btn">
          <div class="manage" @click="manageType = true" v-if="!manageType">
            管理
          </div>
          <div class="manage cancel" @click="manageType = false" v-else>
            取消
          </div>
        </div>
      </TitleControl>
    </div>
    <div class="wrap-content">
      <div class="del-box" v-if="manageType">
        <div class="radio">
          <el-checkbox
            v-model="allChecked"
            @change="changeAllChecked"
          ></el-checkbox>
        </div>
        <div
          class="btn"
          @click="
            handleDelete(
              list.filter((item) => item.checked),
              0
            )
          "
        >
          删除
        </div>
      </div>
      <div class="list">
        <div class="list-item" v-for="item in list" :key="item.id">
          <div
            class="time"
            v-if="item.time"
            :style="manageType ? { marginLeft: '60px' } : ''"
          >
            {{ item.time.slice(0, 10) }}
          </div>
          <div class="item-box">
            <div class="radio" v-if="manageType">
              <el-checkbox v-model="item.checked"></el-checkbox>
            </div>
            <div
              class="card"
              :style="manageType ? { width: 'calc(100% - 60px)' } : ''"
            >
              <BrowseHistoryCard
                :info="item"
                :manageType="manageType"
                @handleDelete="handleDelete([item])"
                @handleReport="handleReport(item)"
                @handleToDetail="
                  handleToDetail(item, 'question', {
                    forum_id: 'forum_id',
                  })
                "
              />
            </div>
          </div>
        </div>
        <el-empty v-if="finished" description="没有更多数据"></el-empty>
      </div>
    </div>
    <Report :type="6" :info="report_info" v-model="reportVisible" />
  </div>
</template>

<script>
import BrowseHistoryCard from "@/components/card/forum/browse-history-card.vue";
import TitleControl from "@/components/module/title-control.vue";
import Report from "@/components/module/report.vue";
import { ForumService, GeneralService } from "@/common/service";
export default {
  components: { BrowseHistoryCard, TitleControl, Report },
  data() {
    return {
      list: [],
      params: {
        page: 1,
        page_num: 20,
        sort_type: 1,
      },
      // 是否无数据
      finished: false,
      // 是否点击管理按钮
      manageType: false,
      // 是否选中所有
      allChecked: false,
      // 当前选中类型
      type: 0,
      // 举报弹窗
      reportVisible: false,
      // 举报项
      report_info: {},
      // 日期
      dateArr: [],
      // 搜索
      list_copy: "",
    };
  },
  watch: {
    manageType(val) {
      !val ? (this.allChecked = false) : "";
      this.list.forEach((item) => (item.checked = false));
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 触底
    TouchBottom() {
      if (!this.finished) {
        this.getList();
      }
    },
    // 选择全部
    changeAllChecked(type) {
      this.list.map((item) => (item.checked = type));
    },
    // 获取数据
    getList() {
      ForumService.getForumTrack(this.params).then(({ data }) => {
        const list = data.list.map((item) => {
          let time = item.time.slice(0, 10);
          this.dateArr.includes(time)
            ? (item.time = "")
            : this.dateArr.push(time);
          return { checked: false, ...item };
        });

        this.list = this.params.page === 1 ? list : [...this.list, ...list];
        if (list.length < this.params.page_num) {
          this.finished = true;
        } else {
          this.params.page++;
        }
      });
    },
    // 删除记录
    handleDelete(arr) {
      let that = this;
      this.showConfirmPopup("确定要删除该信息？")
        .then(() => {
          let params = {
            id: "",
          };
          params.id = arr.map((item) => item.id).join(",");
          if (!params.id) return;
          GeneralService.delTrack(params).then(({ data }) => {
            let list = that.list
              .map((item) => {
                return params.id.split(",").includes(item.id + "") ? "" : item;
              })
              .filter((item) => item);
            that.list = list;
            that.$message.success("删除成功！");
            that.manageType = false;
          });
        })
        .catch((_) => {});
    },
    // 举报
    handleReport(item) {
      this.report_info = item;
      this.reportVisible = true;
    },
    // 跳转详情
    handleToDetail(
      item,
      type = "question",
      key = { forum_id: "forum_id", reply_id: "id" }
    ) {
      if (Object.keys(item).includes("is_normal") && !item.is_normal)
        return this.$message.error("该问题已失效");
      this.$router
        .push({
          path:
            type == "question"
              ? "/forum-question-details"
              : "/forum-answer-item",
          query: {
            forum_id: item[key.forum_id],
            reply_id: item[key.reply_id],
          },
        })
        .catch(() => {});
    },
    // 筛选
    handleSearch(val) {
      if (!this.list_copy) this.list_copy = this.list;
      if (val) {
        this.list = this.list_copy.filter((item) => {
          return item.title.includes(val) || item.series_title.includes(val);
        });
      } else {
        this.list = this.list_copy;
        this.list_copy = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .wrap-title {
    width: 80%;
  }
  .wrap-content {
    width: 80%;
    margin-top: 20px;
    .del-box {
      display: flex;
      align-items: center;
      margin: 0px 0 20px;
      .radio {
        width: 45px;
        display: flex;
        justify-content: center;
        margin-right: 20px;
      }
      .btn {
        width: 80px;
        height: 30px;
        border-radius: 17px;
        color: #ffffff;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
        line-height: 30px;
        cursor: pointer;
        background: #ff9f18;
      }
    }
    .list {
      .list-item {
        margin-bottom: 20px;
        .time {
          font-size: 18px;
          color: #222222;
          margin-bottom: 15px;
        }
        .item-box {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          position: relative;
          .radio {
            width: 45px;
            background-color: white;
            display: flex;
            align-items: center;
            justify-content: center;
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            border-radius: 10px;
          }
          .card {
            width: 100%;
          }
        }
      }
    }
  }
}
.control-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  user-select: none;
  .is-read {
    width: 100px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f4f4f4;
    border-radius: 17px;
    font-size: 13px;
    font-weight: 400;
    color: #1677ff;
    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
  .manage {
    width: 70px;
    height: 30px;
    background: #2a63f3;
    border-radius: 17px;
    font-size: 13px;
    font-weight: 400;
    text-align: center;
    line-height: 30px;
    color: #ffffff;
    margin-left: 10px;
  }
  .cancel {
    background: transparent;
    color: #1677ff;
  }
}
</style>
